module.exports = __webpack_public_path__ + "static/media/healthcare-medical-stethoscope-svgrepo-com.510c3dff.svg";